import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import useClientTabMissingFields from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/useClientTabMissingFields'

const IsResident = () => {
  const { t, errors, isResidentValue, showIsResident, updateAddress, optionalResidenceFields } = useAddress()
  const isMissing = useClientTabMissingFields()
  if (!showIsResident) {
    return null
  }
  return (
    <SDFormControl
      plainLabel
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.is_resident'),
          }}
        />
      )}
      error={getError('isResident', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddress({ isResident: value })
        }}
        options={[{ 1: t('common:yes_text') }, { 0: t('common:no_text') }]}
        selectedValue={isResidentValue}
        missing={isMissing('isResident')}
      />
    </SDFormControl>
  )
}

export default IsResident
